import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
type Language = 'ua' | 'en';
type TrustStripProps = {
  language: Language;
};
const stats = {
  ua: [{
    value: '60',
    suffix: '+',
    label: 'років',
    sublabel: 'досконалості'
  }, {
    value: '80',
    suffix: '',
    label: 'країн',
    sublabel: 'де ми представлені'
  }, {
    value: '70',
    suffix: '+',
    label: 'аерозолів',
    sublabel: 'у асортименті'
  }, {
    value: '360',
    suffix: '',
    label: 'продуктів',
    sublabel: 'для різних сфер'
  }],
  en: [{
    value: '60',
    suffix: '+',
    label: 'years',
    sublabel: 'of excellence'
  }, {
    value: '80',
    suffix: '',
    label: 'countries',
    sublabel: 'where we operate'
  }, {
    value: '70',
    suffix: '+',
    label: 'aerosols',
    sublabel: 'in our range'
  }, {
    value: '360',
    suffix: '',
    label: 'products',
    sublabel: 'for various industries'
  }]
};
export function TrustStrip({
  language
}: TrustStripProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const t = stats[language];
  return <section ref={ref} className="relative py-12 sm:py-16 lg:py-20 bg-chamaleon-black overflow-hidden" data-id="element-302">
      {/* Refined top border */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" data-id="element-303" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-304">
        {/* Mobile: 1 column (vertical stack), Desktop: 4 columns */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8" data-id="element-305">
          {t.map((stat, index) => <motion.div key={stat.label} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="relative group" data-id="element-306">
              <div className="glass-card rounded-xl lg:rounded-2xl p-6 lg:p-8 text-center h-full" data-id="element-307">
                {/* Value */}
                <div className="flex items-baseline justify-center gap-1 mb-3" data-id="element-308">
                  <motion.span initial={{
                opacity: 0,
                scale: 0.5
              }} animate={isInView ? {
                opacity: 1,
                scale: 1
              } : {}} transition={{
                duration: 0.8,
                delay: index * 0.1 + 0.2
              }} className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white" data-id="element-309">
                    {stat.value}
                  </motion.span>
                  {stat.suffix && <span className="text-2xl sm:text-3xl font-bold text-chamaleon-orange" data-id="element-310">
                      {stat.suffix}
                    </span>}
                </div>

                {/* Label */}
                <div className="text-chamaleon-orange font-medium text-sm sm:text-base mb-2" data-id="element-311">
                  {stat.label}
                </div>

                {/* Sublabel */}
                <div className="text-gray-500 text-xs sm:text-sm" data-id="element-312">
                  {stat.sublabel}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>

      {/* Refined bottom border */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" data-id="element-313" />
    </section>;
}